//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date :15/12/2023
// Version : 1
// Description : Para ver el detalle de los reclamos (motivos,detalle,usuario y técnico)
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date : 12-3
// Change by : Magali Perea
// Change description: Se añadio al detalle el encargado de pagar los costos del reclamo.
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HomeIcon from "@mui/icons-material/Home";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";
import BuildIcon from "@mui/icons-material/Build";
import CallIcon from "@mui/icons-material/Call";

const ListItemComponent = ({ icon, primary, secondary }) => (
  <ListItem
    sx={{
      alignItems: "flex-start",
    }}
  >
    <ListItemAvatar>
      <Avatar
        sx={{
          bgcolor: "#4085afff",
          color: "primary.main",
          border: "3px solid white",
          width: 30,
          height: 30,
          boxShadow: 8,
        }}
      >
        {icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText
      primary={
        <Typography
          component="div"
          variant="subtitle1"
          fontWeight="bold"
          color="text.primary"
        >
          {primary}
        </Typography>
      }
      secondary={
        <Typography
          variant="body2"
          component="div"
          color="text.secondary"
          sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {secondary}
        </Typography>
      }
    />
  </ListItem>
);

const DetalleReclamo = (props) => {
  const { datos, row } = props;
  const [tanque, setTanque] = useState([]);

  // console.log("DATOS DETALLE", datos);
  // console.log("ROW", row.original);

  const obtenerTanque = () => {
    fetch(UrlApi + "/reclamos/detalleTanques2/" + row.original.uuid_tanques)
      .then((data) => data.json())
      .then((data) => setTanque(data));
  };

  useEffect(() => {
    obtenerTanque();
  }, [row]);

  // console.log("TANQUES", tanque);
  // console.log("UUID TANQUE ROW", row.original.uuid_tanques);
  // console.log("TANQUES CAPACIDAD", tanque.capacidad);

  return (
    <div>
      <Grid container>
        <List
          sx={{
            width: "1300px",
            boxShadow: 3,
            border: 0.5,
            borderRadius: 5,
            borderColor: "#b5bcc0ff",
            display: "flex",
          }}
        >
          <ListItemComponent
            icon={<HomeIcon sx={{ color: "#ffffff " }} />}
            primary="Dirección de entrega"
            secondary={`${datos.lugar_entrega} - ${datos.nombre_direccion} - ${datos.localidad} - ${datos.provincias}`}
          />
          <ListItemComponent
            icon={<CallIcon sx={{ color: "#ffffff " }} />}
            primary="Contacto"
            secondary={`${
              datos.contacto || "Sin nombre de contacto"
            } - Teléfono:${
              datos.telefono1 ||
              datos.telefono2 ||
              datos.telefono3 ||
              datos.tel_cli1 ||
              datos.tel_cli2 ||
              datos.tel_cli3 ||
              "Sin teléfono"
            }`}
          />
          <ListItemComponent
            icon={<PersonIcon sx={{ color: "#ffffff " }} />}
            primary="Usuario"
            secondary={datos.usuario}
          />
          {datos.a_cargo ? (
            <ListItemComponent
              icon={<AttachMoneyIcon sx={{ color: "#ffffff" }} />}
              primary="Responsable gastos"
              secondary={datos.valor_cargo}
            />
          ) : null}
          {datos.proveedor ? (
            <ListItemComponent
              icon={<BuildIcon sx={{ color: "#ffffff " }} />}
              primary="Técnico"
              secondary={`${datos.proveedor} - Teléfono: ${datos.telefono}`}
            />
          ) : (
            <ListItemComponent
              icon={<BuildIcon sx={{ color: "#ffffff " }} />}
              primary="Técnico"
              secondary={"No Hay Técnico Asignado"}
            />
          )}
        </List>
        <List
          sx={{
            width: "1300px",
            boxShadow: 3,
            border: 0.5,
            borderRadius: 5,
            borderColor: "#b5bcc0ff",
            display: "flex",
            marginTop: 2,
          }}
        >
          <ListItemComponent
            icon={<AssignmentIcon sx={{ color: "#ffffff " }} />}
            primary="Detalle del problema"
            secondary={datos.detalle}
          />
          <ListItemComponent
            icon={<PropaneTankIcon sx={{ color: "#ffffff " }} />}
            primary="Tanques"
            secondary={
              tanque && tanque.length > 0 ? (
                // <Typography component="div">
                <ul style={{ margin: 0, paddingLeft: 16 }}>
                  {tanque.map((t) => (
                    <li key={t.id_tanque}>
                      N° serie: {t.nro_serie} – capacidad: {t.capacidad}jhgyjgjyufjyf
                    </li>
                  ))}
                </ul>
              ) : (
                // </Typography>
                "No hay tanques"
              )
            }
          />
        </List>

        {/* Detalle de Finalización */}
        {datos.estado === 171 && (
          <List
            sx={{
              width: "1300px",
              boxShadow: 3,
              border: 0.5,
              borderRadius: 5,
              borderColor: "#b5bcc0ff",
              //  borderColor: "#A9CCE3",
              display: "flex",
              marginTop: 2,
            }}
          >
            <ListItemComponent
              icon={
                <CheckCircleOutlineIcon
                  sx={{
                    color: "#ffffff", // color
                    stroke: "#54ff2c", // borde
                    strokeWidth: 0.8, // grosor del borde
                  }}
                />
              }
              primary="Acciones realizadas"
              secondary={datos.detalles_finalizacion}
            />
          </List>
        )}

        {/* Detalle de Cancelación */}
        {datos.estado === 223 && (
          <List
            sx={{
              width: "1300px",
              boxShadow: 3,
              border: 0.5,
              borderRadius: 5,
              borderColor: "#b5bcc0ff",
              display: "flex",
              marginTop: 2,
            }}
          >
            <ListItemComponent
              icon={
                <DoDisturbAltIcon
                  sx={{
                    color: "#ffffff", // color
                    stroke: "#ff4000", // borde
                    strokeWidth: 0.8, // grosor del borde
                  }}
                />
              }
              primary="Motivo de cancelación"
              secondary={datos.detalles_cancelacion}
            />
          </List>
        )}
      </Grid>
    </div>
  );
};

export default DetalleReclamo;
